import { createSlice } from "@reduxjs/toolkit";
import Transaction from "../Actions/GetTransaction-Action";
const initialState = {
  TransactionData: [],
  searchData: [],
  showSearch: false,
  loading: false,
  status: "",
  isLoaded: false,
  lastEvaluatedkey: "",
  loadMore: false,
};

const Transactions = createSlice({
  name: "Transactions list",
  initialState,
  reducers: {
    setIsLoaded(state, action) {
      state.isLoaded = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setSearchData(state, action) {
      state.searchData = action.payload;
    },
    setShowSearch(state, action) {
      state.showSearch = action.payload;
    },
    setLoadMore(state, action) {
      state.loadMore = action.payload;
    },
  },
  extraReducers: {
    [Transaction.pending]: (state, action) => {
      if (state.lastEvaluatedkey === "") {
        state.loading = true;
      } else {
        state.loadMore = true;
      }
    },
    [Transaction.fulfilled]: (state, action) => {
      if (action.payload.error) {
        state.status = action.payload.error;
        state.loading = false;
        state.loadMore = false;
        return;
      }
      let currentArr = state.TransactionData;
      let newArr = [];
      newArr = action.payload.Items;
      state.TransactionData = currentArr.concat(newArr);
      state.lastEvaluatedkey = action?.payload?.LastEvaluatedKey
        ? action.payload.LastEvaluatedKey
        : "";
      state.loading = false;
      state.loadMore = false;
    },
    [Transaction.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.error.message;
      state.loadMore = false;
    },
  },
});

export const TransactionAction = Transactions.actions;

export default Transactions.reducer;
